var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Hero'),_c('main',{attrs:{"id":"main"}},[_c('About'),_c('Services'),_c('Skills'),_c('Pricing'),_c('Contact')],1),_c('Footer'),_c('Preloader'),_c('BackToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }